/**
 * 新版大屏
 */
import axios from "../axios";
import {
    ILargeScreenAddAreaFileParams,
    ILargeScreenAddCompanyFileParams,
    ILargeScreenAlaramHistoryParams,
    ILargeScreenGetAreaFileData as ILargeScreenGetAreaFileData,
    ILargeScreenGetAreaFileParams as ILargeScreenGetAreaFileParams,
    ILargeScreenGetAlarmListData,
    ILargeScreenGetAlarmListParams,
    ILargeScreenGetAlarmRankingData,
    ILargeScreenGetAlarmRankingParams,
    ILargeScreenGetCompanyCoordinatesData,
    ILargeScreenGetCompanyCoordinatesParams,
    ILargeScreenGetCompanyListByProvinceData,
    ILargeScreenGetCompanyListByProvinceParams,
    ILargeScreenGetCompanyScreenData,
    ILargeScreenGetCompanyScreenParams,
    ILargeScreenGetCompanyStatisticsData,
    ILargeScreenGetCompanyStatisticsParams,
    ILargeScreenGetEquipmentAlarmStatistics,
    ILargeScreenGetEquipmentAlarmStatisticsData,
    ILargeScreenGetLargeScreenStatistics,
    ILargeScreenGetLargeScreenStatisticsData,
    ILargeScreenGetMachineStatisticsData,
    ILargeScreenGetMachineStatisticsParams,
    ILargeScreenGetMappingAlarmStatisticsRecordData,
    ILargeScreenGetMappingAlarmStatisticsRecordParams,
    ILargeScreenGetSensorRankingData,
    ILargeScreenGetSensorRankingParams,
    ILargeScreenGetSensorStatisticsData,
    ILargeScreenGetSensorStatisticsParams,
    ILargeScreenSetCoordinatesParams,
    ILargeScreenGetOrdinaryCompanyStatisticsData,
    ILargeScreenGetOrdinaryCompanyStatisticsParams,
    ILargeScreenGetAlarmStatisticsParams,
    ILargeScreenGetAlarmStatisticsParamsData,
    ILargeScreenAddParentCompanyFileParams,
    ILargeScreenV2AlarmTrendParams,
    ILargeScreenV2AlarmTrendData,
    ILargeScreenV2CurrentStatusSensorData,
    ILargeScreenV2FaultDiagnosisStatisticsParams,
    ILargeScreenV2FaultDiagnosisStatisticsData,
    ILargeScreenV2EquipmentRunStatisticsParams,
    ILargeScreenV2EquipmentRunStatisticsData,
    ILargeScreenV2HealthScoreStatisticsData,
    ILargeScreenV2TodayAlarmStatisticsParams,
    ILargeScreenV2TodayAlarmStatisticsData,
    ILargeScreenV2TodayStatusNumSensorData,
    ILargeScreenV2TodayStatusNumSensorParams,
    ILargeScreenV2UndisposedAlarmListParams,
    ILargeScreenV2UndisposedAlarmListData,
    ILargeScreenV2QueryCompanyAreaParams,
    ILargeScreenV2QueryCompanyAreaData,
    ILargeScreenV2QueryCompanyParams,
    ILargeScreenV2QueryCompanyData,
    ILargeScreenV2PlatformAlarmTop10Data,
    ILargeScreenV2PlatformDiagnosisTrendData,
    ILargeScreenV2PlatformDiagnosisTrendParams,
    ILargeScreenV2PlatformEquipmentStatusData,
    ILargeScreenV2PlatformIndustryDistributionData,
    ILargeScreenV2PlatformMapDistributionData,
    ILargeScreenV2PlatformOverviewData,
    ILargeScreenV2PlatformSensorTypeDistributionData,
    ILargeScreenV2PlatformTodayAlarmData,
    ILargeScreenV2HealthScoreStatisticsParams,
    ILargeScreenV2CurrentStatusSensorParams,
    ILargeScreenV2ParentAlarmTrendParams,
    ILargeScreenV2ParentFaultDiagnosisStatisticsData,
    ILargeScreenV2ParentFaultDiagnosisStatisticsParams,
    ILargeScreenV2ParentFaultDiagnosisTrendData,
    ILargeScreenV2ParentFaultDiagnosisTrendParams,
    ILargeScreenV2ParentGetSensorStatisticsListData,
    ILargeScreenV2ParentGetSensorStatisticsListParams,
    ILargeScreenV2ParentCompanyMapStatisticsData,
    ILargeScreenV2ParentHealthScoreStatisticsData,
    ILargeScreenV2ParentHealthScoreStatisticsParams,
    ILargeScreenV2ParentQueryEquipmentRunStatisticsData,
    ILargeScreenV2ParentQueryEquipmentRunStatisticsParams,
    ILargeScreenV2ParentTodayAlarmStatisticsData,
    ILargeScreenV2ParentTodayAlarmStatisticsParams,
    ILlargeScreenV2ParentAlarmTrendData,
    ILargeScreenV2ParentParentMapListData
} from "./largeScreen.types";

/**
 * 添加区域图片
 */
export function largeScreenAddAreaFile(params: ILargeScreenAddAreaFileParams) {
    return axios({
        method: 'post',
        url: '/large/screen/addAreaFile',
        data: params,
    })
}


/**
 * 添加公司图片
 */
export function largeScreenAddCompanyFile(params: ILargeScreenAddCompanyFileParams) {
    return axios({
        method: 'post',
        url: '/large/screen/addCompanyFile',
        data: params,
    })
}


/**
 * 获取最新报警
 */
export function largeScreenGetAlarmList(params: ILargeScreenGetAlarmListParams) {
    return axios<ILargeScreenGetAlarmListData>({
        method: 'get',
        url: '/large/screen/getAlarmList',
        params,
    })
}


/**
 * 获取区域图
 */
export function largeScreenGetAreaFile(params: ILargeScreenGetAreaFileParams) {
    return axios<ILargeScreenGetAreaFileData>({
        method: 'get',
        url: '/large/screen/getAreaFile',
        params,
    })
}


/**
 * 获取公司坐标详情
 */
export function largeScreenGetCompanyCoordinates(params: ILargeScreenGetCompanyCoordinatesParams) {
    return axios<ILargeScreenGetCompanyCoordinatesData>({
        method: 'get',
        url: '/large/screen/getCompanyCoordinates',
        params,
    })
}


/**
 * 公司大屏首页-每个区域设备传感器数量
 */
export function largeScreenGetCompanyScreen(params: ILargeScreenGetCompanyScreenParams) {
    return axios<ILargeScreenGetCompanyScreenData>({
        method: 'get',
        url: '/large/screen/getCompanyScreen',
        params,
    })
}


/**
 * 公司统计-设备/传感器/故障诊断数量
 */
export function largeScreenGetCompanyStatistics(params: ILargeScreenGetCompanyStatisticsParams) {
    return axios<ILargeScreenGetCompanyStatisticsData>({
        method: 'get',
        url: '/large/screen/getCompanyStatistics',
        params,
    })
}


/**
 * 传感器统计
 */
export function largeScreenGetSensorStatistics(params: ILargeScreenGetSensorStatisticsParams) {
    return axios<ILargeScreenGetSensorStatisticsData>({
        method: 'get',
        url: '/large/screen/getSensorStatistics',
        params,
    })
}

/**
 * 区域坐标设置
 */
export function largeScreenSetCoordinates(params: ILargeScreenSetCoordinatesParams) {
    return axios({
        method: 'post',
        url: '/large/screen/setCoordinates',
        data: params,
    })
}

/**
 * 普通公司数量统计 
 */
export function largeScreenGetOrdinaryCompanyStatistics(params: ILargeScreenGetOrdinaryCompanyStatisticsParams) {
    return axios<ILargeScreenGetOrdinaryCompanyStatisticsData>({
        method: 'get',
        url: '/large/screen/getOrdinaryCompanyStatistics',
        params,
    })
}


/**
 * 添加总公司图片
 */
export function largeScreenAddParentCompanyFile(params: ILargeScreenAddParentCompanyFileParams) {
    return axios({
        method: 'post',
        url: '/large/screen/addParentCompanyFile',
        data: params,
    })
}


/**
 * 报警趋势统计 
 */
export function largeScreenGetAlarmStatistics(params: ILargeScreenGetAlarmStatisticsParams) {
    return axios<ILargeScreenGetAlarmStatisticsParamsData>({
        method: 'get',
        url: '/large/screen/getAlarmStatistics',
        params,
    })
}


//#region 总公司大屏

/**
 * 总公司大屏 月报警排行
 */
export function largeScreenGetAlarmRanking(params?: ILargeScreenGetAlarmRankingParams) {
    return axios<ILargeScreenGetAlarmRankingData>({
        method: 'get',
        url: '/large/screen/getAlarmRanking',
        params,
    })
}


/**
 * 总公司大屏 月设备统计
 */
export function largeScreenGetEquipmentAlarmStatistics(params?: ILargeScreenGetEquipmentAlarmStatistics) {
    return axios<ILargeScreenGetEquipmentAlarmStatisticsData>({
        method: 'get',
        url: '/large/screen/getEquipmentAlarmStatistics',
        params,
    })
}


/**
 * 总公司大屏 地图统计和城市占比
 */
export function largeScreenGetLargeScreenStatistics(params?: ILargeScreenGetLargeScreenStatistics) {
    return axios<ILargeScreenGetLargeScreenStatisticsData>({
        method: 'get',
        url: '/large/screen/getLargeScreenStatistics',
        params,
    })
}


/**
 * 总公司大屏 左侧设备统计
 */
export function largeScreenGetMachineStatistics(params?: ILargeScreenGetMachineStatisticsParams) {
    return axios<ILargeScreenGetMachineStatisticsData>({
        method: 'get',
        url: '/large/screen/getMachineStatistics',
        params,
    })
}


/**
 *  总公司大屏 传感器排行
 */
export function largeScreenGetSensorRanking(params?: ILargeScreenGetSensorRankingParams) {
    return axios<ILargeScreenGetSensorRankingData>({
        method: 'get',
        url: '/large/screen/getSensorRanking',
        params,
    })
}

/**
 * 总公司大屏 根据省份获取公司
 */
export function largeScreenGetCompanyListByProvince(params: ILargeScreenGetCompanyListByProvinceParams) {
    return axios<ILargeScreenGetCompanyListByProvinceData>({
        method: 'get',
        url: '/large/screen/getCompanyListByProvince',
        params,
    })
}

/**
 * 总公司大屏 公司报警记录
 */
export function largeScreenAlaramHistory(params: ILargeScreenAlaramHistoryParams) {
    return axios({
        method: 'get',
        url: '/large/screen/alarm/history',
        params
    })
}

/**
 * 总公司大屏 月测点报警记录统计
 */
export function largeScreenGetMappingAlarmStatisticsRecord(params: ILargeScreenGetMappingAlarmStatisticsRecordParams) {
    return axios<ILargeScreenGetMappingAlarmStatisticsRecordData>({
        method: 'get',
        url: '/large/screen/getMappingAlarmStatisticsRecord',
        params,
    })
}

//#endregion


// V2
/**
 * 告警趋势 
 */
export function largeScreenV2AlarmTrend(params: ILargeScreenV2AlarmTrendParams) {
    return axios<ILargeScreenV2AlarmTrendData>({
        method: 'get',
        url: '/large/screen/v2/alarmTrend',
        params,
    })
}

/**
 * 传感器当前状态 
 */
export function largeScreenV2CurrentStatusSensor(params: ILargeScreenV2CurrentStatusSensorParams) {
    return axios<ILargeScreenV2CurrentStatusSensorData>({
        method: 'get',
        url: '/large/screen/v2/currentStatusSensor',
        params,
    })
}

/**
 *  故障诊断统计
 */
export function largeScreenV2FaultDiagnosisStatistics(params: ILargeScreenV2FaultDiagnosisStatisticsParams) {
    return axios<ILargeScreenV2FaultDiagnosisStatisticsData>({
        method: 'get',
        url: '/large/screen/v2/faultDiagnosisStatistics',
        params,
    })
}

/**
 *  大屏设备开机率统计
 */
export function largeScreenV2EquipmentRunStatistics(params: ILargeScreenV2EquipmentRunStatisticsParams) {
    return axios<ILargeScreenV2EquipmentRunStatisticsData>({
        method: 'get',
        url: '/large/screen/v2/queryEquipmentRunStatistics',
        params,
    })
}

/**
 *  大屏健康评分统计
 */
export function largeScreenV2HealthScoreStatistics(params: ILargeScreenV2HealthScoreStatisticsParams) {
    return axios<ILargeScreenV2HealthScoreStatisticsData>({
        method: 'get',
        url: '/large/screen/v2/healthScoreStatistics',
        params,
    })
}

/**
 *  今日告警
 */
export function largeScreenV2TodayAlarmStatistics(params: ILargeScreenV2TodayAlarmStatisticsParams) {
    return axios<ILargeScreenV2TodayAlarmStatisticsData>({
        method: 'get',
        url: '/large/screen/v2/todayAlarmStatistics',
        params,
    })
}

/**
 *  区域传感器状态
 */
export function largeScreenV2TodayStatusNumSensor(params: ILargeScreenV2TodayStatusNumSensorParams) {
    return axios<ILargeScreenV2TodayStatusNumSensorData>({
        method: 'get',
        url: '/large/screen/v2/todayStatusNumSensor',
        params,
    })
}

/**
 *  未处理报警记录
 */
export function largeScreenV2UndisposedAlarmList(params: ILargeScreenV2UndisposedAlarmListParams) {
    return axios<ILargeScreenV2UndisposedAlarmListData>({
        method: 'get',
        url: '/large/screen/v2/undisposedAlarmList',
        params,
    })
}

/**
 *  获取大屏区域详情
 */
export function largeScreenV2QueryCompanyArea(params: ILargeScreenV2QueryCompanyAreaParams) {
    return axios<ILargeScreenV2QueryCompanyAreaData>({
        method: 'get',
        url: '/large/screen/v2/queryCompanyAreaLargeScreen',
        params,
    })
}

/**
 *  获取大屏公司详情
 */
export function largeScreenV2QueryCompany(params: ILargeScreenV2QueryCompanyParams) {
    return axios<ILargeScreenV2QueryCompanyData>({
        method: 'get',
        url: '/large/screen/v2/queryCompanyLargeScreen',
        params,
    })
}

/**
 * 平台大屏顶部总览统计
 */
export function largeScreenV2PlatformOverview() {
    return axios<ILargeScreenV2PlatformOverviewData>({
        method: 'get',
        url: '/large/screen/v2/platform/overview',
    })
}

/**
 * 平台大屏地图分布统计
 */
export function largeScreenV2PlatformMapDistribution() {
    return axios<ILargeScreenV2PlatformMapDistributionData>({
        method: 'get',
        url: '/large/screen/v2/platform/mapDistribution',
    })
}

/**
 * 平台大屏传感器类型分布统计
 */
export function largeScreenV2PlatformSensorTypeDistribution() {
    return axios<ILargeScreenV2PlatformSensorTypeDistributionData>({
        method: 'get',
        url: '/large/screen/v2/platform/sensorTypeDistribution',
    })
}

/**
 * 平台大屏设备状态统计
 */
export function largeScreenV2PlatformEquipmentStatus() {
    return axios<ILargeScreenV2PlatformEquipmentStatusData>({
        method: 'get',
        url: '/large/screen/v2/platform/equipmentStatus',
    })
}

/**
 * 平台大屏今日告警统计
 */
export function largeScreenV2PlatformTodayAlarm() {
    return axios<ILargeScreenV2PlatformTodayAlarmData>({
        method: 'get',
        url: '/large/screen/v2/platform/todayAlarm',
    })
}

/**
 * 平台大屏智能诊断趋势统计
 */
export function largeScreenV2PlatformDiagnosisTrend(params?: ILargeScreenV2PlatformDiagnosisTrendParams) {
    return axios<ILargeScreenV2PlatformDiagnosisTrendData>({
        method: 'get',
        url: '/large/screen/v2/platform/diagnosisTrend',
        params,
    })
}

/**
 * 平台大屏实时告警排行Top10
 */
export function largeScreenV2PlatformAlarmTop10() {
    return axios<ILargeScreenV2PlatformAlarmTop10Data>({
        method: 'get',
        url: '/large/screen/v2/platform/alarmTop10',
    })
}

/**
 * 平台大屏行业分布统计
 */
export function largeScreenV2PlatformIndustryDistribution() {
    return axios<ILargeScreenV2PlatformIndustryDistributionData>({
        method: 'get',
        url: '/large/screen/v2/platform/industryDistribution',
    })
}

/**
 * 总公司-新版大屏V2
 */

/**
 * 总公司-今日告警
 */
export function largeScreenV2ParentAlarmTrend(params?: ILargeScreenV2ParentAlarmTrendParams) {
    return axios<ILlargeScreenV2ParentAlarmTrendData>({
        method: 'get',
        url: '/large/screen/parent/v2/alarmTrend',
        params,
    })
}

/**
 * 总公司-故障诊断统计
 */
export function largeScreenV2ParentFaultDiagnosisStatistics(params?: ILargeScreenV2ParentFaultDiagnosisStatisticsParams) {
    return axios<ILargeScreenV2ParentFaultDiagnosisStatisticsData>({
        method: 'get',
        url: '/large/screen/parent/v2/faultDiagnosisStatistics',
        params,
    })
}

/**
 * 总公司-故障诊断趋势
 */
export function largeScreenV2ParentFaultDiagnosisTrend(params?: ILargeScreenV2ParentFaultDiagnosisTrendParams) {
    return axios<ILargeScreenV2ParentFaultDiagnosisTrendData>({
        method: 'get',
        url: '/large/screen/parent/v2/faultDiagnosisTrend',
        params,
    })
}

/**
 * 总公司-大屏地图报警统计
 */
export function largeScreenV2ParentParentMapList() {
    return axios<ILargeScreenV2ParentParentMapListData>({
        method: 'get',
        url: '/large/screen/parent/v2/getParentMapList',
    })
}

/**
 * 总公司-传感器分布
 */
export function largeScreenV2ParentGetSensorStatisticsList(params?: ILargeScreenV2ParentGetSensorStatisticsListParams) {
    return axios<ILargeScreenV2ParentGetSensorStatisticsListData>({
        method: 'get',
        url: '/large/screen/parent/v2/getSensorStatisticsList',
        params,
    })
}

/**
 * 总公司-大屏健康评分统计
 */
export function largeScreenV2ParentHealthScoreStatistics(params?: ILargeScreenV2ParentHealthScoreStatisticsParams) {
    return axios<ILargeScreenV2ParentHealthScoreStatisticsData>({
        method: 'get',
        url: '/large/screen/parent/v2/healthScoreStatistics',
        params,
    })
}

/**
 * 总公司-大屏设备开机率统计
 */
export function largeScreenV2ParentCompanyMapStatistics() {
    return axios<ILargeScreenV2ParentCompanyMapStatisticsData>({
        method: 'get',
        url: '/large/screen/parent/v2/queryCompanyMapRunStatistics',
    })
}

/**
 * 总公司-大屏设备开机率统计
 */
export function largeScreenV2ParentQueryEquipmentRunStatistics(params?: ILargeScreenV2ParentQueryEquipmentRunStatisticsParams) {
    return axios<ILargeScreenV2ParentQueryEquipmentRunStatisticsData>({
        method: 'get',
        url: '/large/screen/parent/v2/queryEquipmentRunStatistics',
        params,
    })
}

/**
 * 总公司-总公司-告警分布
 */
export function largeScreenV2ParentTodayAlarmStatistics(params?: ILargeScreenV2ParentTodayAlarmStatisticsParams) {
    return axios<ILargeScreenV2ParentTodayAlarmStatisticsData>({
        method: 'get',
        url: '/large/screen/parent/v2/todayAlarmStatistics',
        params,
    })
}
